import React, { useContext } from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { media } from 'styles/media'
import { H1, fontWeights, Lead } from 'styles/typography'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import Button from 'components/button/Button'
import { NativeAuthConsumer } from 'components/NativeAuth'
import SaasquatchContext from 'contexts/Saasquatch'

const Container = styled.div`
  position: relative;
  text-align: center;
  background-color: #cbb482;
  padding-top: 2rem;
  padding-bottom: 5rem;
  background-image: url('${process.env.BASE_PATH}/images/refer/background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${media.small`
    padding-top: 2.5rem;
    padding-bottom: 6rem;
  `};

  ${media.medium`
    padding-top: 3rem;
    padding-bottom: 7rem;
  `};

  ${media.large`
    padding-top: 3.5rem;
    padding-bottom: 8rem;
  `};

  ${media.xLarge`
    padding-top: 4rem;
    padding-bottom: 9rem;
  `};
`

const Heading = styled(H1)`
  text-transform: uppercase;
  color: ${white};
  font-family: 'Trim Poster';
  font-size: 32px;

  ${media.medium`
    font-size: 48px;
  `};

  ${media.xLarge`
    font-size: 60px;
  `};
`

const Subheading = styled(Lead)`
  color: ${white};
  font-weight: ${fontWeights.medium};
  margin-bottom: 1.5em;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;

  ${media.small`
    max-width: 450px;
  `};

  ${media.medium`
    max-width: 520px;
  `};

  ${media.large`
    max-width: 600px;
  `};

  ${media.xLarge`
    max-width: 620px;
  `};
`

const Slant = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -1px;
  pointer-events: none;
  max-height: 320px;
`

const Promo = () => {
  const { eligible } = useContext(SaasquatchContext)

  return (
    <Container>
      <Section>
        <Wrapper>
          <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={0} animateOnce>
            INVITE FRIENDS
            <br />
            EARN UP TO $200 IN CREDITS
          </Heading>
          <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
            Invite up to 10 adult nicotine consumers to vuse.com and you could earn up to $200 in credits to use on
            vuse.com.
          </Subheading>

          {/* If user but not yet eligible, link to savings page in account */}
          <NativeAuthConsumer>
            {({ user }) => {
              return user && !eligible ? (
                <ScrollAnimation animateIn="fadeInUp" offset={0} delay={400} animateOnce>
                  <Button to="/account/savings/" theme="custom" customColor={white} variant="outline" size="large">
                    Track your savings
                  </Button>
                </ScrollAnimation>
              ) : null
            }}
          </NativeAuthConsumer>

          {/* If no user, show login button */}
          <NativeAuthConsumer>
            {({ user, setSignupModalVisibility }) => {
              return user ? null : (
                <ScrollAnimation animateIn="fadeInUp" offset={0} delay={400} animateOnce>
                  <Button
                    theme="custom"
                    customColor={white}
                    variant="outline"
                    size="large"
                    onClick={() => {
                      setSignupModalVisibility(true)
                    }}
                  >
                    Log in/get started
                  </Button>
                </ScrollAnimation>
              )
            }}
          </NativeAuthConsumer>
        </Wrapper>
      </Section>
      <Slant src={`${process.env.BASE_PATH}/images/refer/slant.png`} />
    </Container>
  )
}

export default Promo
